import React, { useState, useEffect } from 'react';
import fetchGithubProfileData from './githubProfileData'; // Import your fetch function

function TopRepos() {
  const searchParams = new URLSearchParams(window.location.search);
  const username = searchParams.get("user");
  const [repos, setRepos] = useState([]);

  useEffect(() => {
    // Fetch the data when the component mounts
    const fetchData = async () => {
      const data = await fetchGithubProfileData(username.trim()); // Replace 'username' with dynamic value or prop
      if (data) {
        setRepos(data.repos); // Set the fetched repos
      }
    };
    fetchData();
  }, [username]);

  return (
    <section className="topReposContainer section--lg">
      <h1 style={{ "textAlign": "center" }}>Top Repositories</h1>
      <div className="topRepos">
        {repos.length > 0 ? (
          repos.map((repo, index) => (
            <div key={index} className="repo">
              <div className="repoTitleContainer">
                <i className="fas fa-folder"></i>
                <h3 className="repoTitle">{repo.name}</h3>
              </div>
              <div>
                <p className="repoDesc">{repo.description || 'No description available'}</p>
              </div>
            </div>
          ))
        ) : (
          <p>Loading repositories...</p>
        )}
      </div>
    </section>
  );
}

export default TopRepos;
